





























































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Nav',
  components: {},
  data: function() {
    return {
     
    };
  },
  methods: {
    toggleLogin() {
      this.$store.dispatch('toggleLogin');
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    }
  },
  computed: {
    showLogin() {
      return this.$store.state.showLogin;
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
});
